




































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import LeafRow from './LeafRow.vue'

@Component({
    components: {
        LeafRow
    }
})
export default class Measures extends Vue {

    @Prop() rows!: any; 
    @Prop() propKey!: any;
    @Prop() startingPeriod: boolean;
    @Prop() formOptions: any;
}
